<template>
	<div class="booking-number">
		<form>
			<div class="booking-number-header">
				<h2 class="text-center">Create Job</h2>
				<h5 class="text-center mb-3">with your Booking Number</h5>
			</div>
			<div class="booking-number-content">
				<label class="text-left">Please enter your Booking Number</label>
				<BaseInput
					inputType="buttonAddons"
					class="booking-number-content-search"
					type="text"
					buttonText="Go"
					v-model="bookingNumber"
					:buttonClick="getJobDetails"
				/>
				<p v-if="validationErrors.bookingNumber">{{ validationErrors.bookingNumber }}</p>
			</div>
		</form>
		<div class="booking-number-notification-wrapper" v-if="isBookingNumberNotification">
			<div class="booking-number-notification">
				<p>Checking Booking Details...</p>
			</div>
		</div>
	</div>
</template>

<script>
import NProgress from 'nprogress'
import * as yup from 'yup'
import { getValidationErrors } from '@/utils/Help.js'

const schema = yup.object().shape({
	bookingNumber: yup
		.string()
		.label('Booking Number')
		// .matches(/^100/, {
		// 	message: "Booking Number must start with '100",
		// 	excludeEmptyString: true
		// })
		.required("Booking Number can't be empty.")
})

export default {
	data() {
		return {
			bookingNumber: '',
			validationErrors: {},
			isBookingNumberNotification: false
		}
	},
	methods: {
		async getJobDetails() {
			const bookingNumber = this.bookingNumber.trim().replace(/\s+/g, '')
			this.isBookingNumberNotification = true
			NProgress.start()
			const userInput = {
				bookingNumber
			}
			try {
				await schema.validate(userInput, {
					abortEarly: false
				})
				// const reg = new RegExp('^100|^CP')
				const reg = new RegExp('^100|^[C][P][0-9]{6}[-][0-9]{2}')
				const regResult = reg.test(bookingNumber)
				console.log(regResult, bookingNumber)
				if (regResult) {
					await this.$store.dispatch('job/getJobsParams', {
						bookingNumber
					})
					this.isBookingNumberNotification = false
					NProgress.done()
					this.$router.push({
						name: 'job-create-by-booking-number'
					})
				} else {
					NProgress.done()
					const notification = {
						type: 'error',
						message: `This number is not yet allocated. Please enter your job details manually.`
					}
					this.$store.dispatch('notification/add', notification, {
						root: true
					})
					this.$router.push({
						name: 'job-create'
					})
				}
			} catch (err) {
				this.isBookingNumberNotification = false
				NProgress.done()
				if (err.name === 'ValidationError') {
					this.validationErrors = getValidationErrors(err)
				} else {
					this.$router.push({
						name: 'job-create'
					})
				}
				console.log(err)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/views/bookingNumber.scss';
</style>
